import {
  CANCEL_WITHDRAWAL_REQUEST,
  CHECK_WITHDRAWAL_EXIST,
  CREATE_CRYPTO_WITHDRAW_REQUEST,
  CREATE_WITHDRAW_REQUEST
} from '~/utils/api-response/finance'

// State
export const state = () => ({
  loading: false,
  withdrawalExistingData: {}
})

// Actions
export const actions = {
  // Get check withdrawal
  checkExistWithdrawal({ commit }) {
    const response = CHECK_WITHDRAWAL_EXIST
    commit('setWithdrawalExistingData', response.data)
    return response.data
  },
  // Create withdraw
  createWithdraw({ commit, rootState }, form) {
    const playerBalance =
      parseFloat(this.$cookie.get('player_balance') || '0') || rootState.player.player.balance
    const newBalance = playerBalance - parseFloat(form.amount)
    this.$cookie.set('player_balance', newBalance)
    commit('player/setTotalBalance', newBalance, { root: true })
    commit('player/setPlayerBalance', newBalance, { root: true })

    CREATE_WITHDRAW_REQUEST.withdrawal_amount = form.amount
    const response = CREATE_WITHDRAW_REQUEST
    return response.data
  },
  // Cancel withdraw
  cancelWithdraw({ commit }, id) {
    const response = CANCEL_WITHDRAWAL_REQUEST
    return response.data
  },
  createCryptoWithdrawal({ commit, rootState }, form) {
    const playerBalance =
      parseFloat(this.$cookie.get('player_balance') || '0') || rootState.player.player.balance
    const newBalance = playerBalance - parseFloat(form.amount)
    this.$cookie.set('player_balance', newBalance)
    commit('player/setTotalBalance', newBalance, { root: true })
    commit('player/setPlayerBalance', newBalance, { root: true })

    CREATE_CRYPTO_WITHDRAW_REQUEST.data.withdrawal_amount = form.amount
    const response = CREATE_CRYPTO_WITHDRAW_REQUEST
    return response.data
  }
}

// Mutations
export const mutations = {
  setLoading(state, data) {
    state.loading = data
  },
  setWithdrawalExistingData(state, data) {
    state.withdrawalExistingData = data
  }
}

// Getters
export const getters = {}
